module.exports = __webpack_public_path__ + "img/no_meeting.66f81c2e.png";